import type { PriceLine } from './price-line'
import type { PaymentItemConfiguration } from './payment-item-configuration'

type PaymentSpecification = {
  itemConfigurations: { [string]: PaymentItemConfiguration[]},
  totalsPerPaymentType: { [string]: PriceLine }
}

const buildPaymentSpecification = function () : PaymentSpecification {
  return {
    itemConfigurations: {},
    totalsPerPaymentType: []
  }
}

export {
  PaymentSpecification,
  buildPaymentSpecification
}



// WEBPACK FOOTER //
// ./src/types/payment-specification.js